import {
  Accordion,
  Button,
  EButtonColorVariant,
  EHeadingStyleVariant,
  ETextStyleVariant,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './BecomeAHost.module.css';
import { useHostingRVFlow } from './RV/useHostingRVFlow';

export const FAQs = () => {
  const intl = useIntl();
  const { redirectToHostingRVFlow, loading } = useHostingRVFlow();

  const handleHostingFlow = () => {
    redirectToHostingRVFlow();
  };
  const rvFaqItems = [
    {
      question: intl.formatMessage({
        defaultMessage: 'How much does it cost to list my RV?',
        id: 'Qc5nzs',
      }),
      answer: intl.formatMessage({
        defaultMessage:
          "It's FREE to list on Outdoorsy. A small transaction fee is taken from each successful booking.",
        id: 'yPL0kM',
      }),
    },
    {
      question: intl.formatMessage({
        defaultMessage: 'How does Outdoorsy verify renters?',
        id: '2afsqA',
      }),
      answer: intl.formatMessage({
        defaultMessage:
          "All renters pass an extensive driving history check. We validate renter's driving history in every booking made on our platform.",
        id: 'gKZINA',
      }),
    },
    {
      question: intl.formatMessage({
        defaultMessage: 'Can I decide who can rent my RV?',
        id: 'N8n/BO',
      }),
      answer: intl.formatMessage({
        defaultMessage: 'Yes. You will always have the final say in who gets to rent your RV.',
        id: 'FXl+dY',
      }),
    },
    {
      question: intl.formatMessage({
        defaultMessage: 'How does the pick-up process work?',
        id: 'u9WHQr',
      }),
      answer: intl.formatMessage({
        defaultMessage:
          "You'll arrange to meet with renters on the day of pick up to exchange keys & give them a walkthrough of your RV.",
        id: '7Cjqar',
      }),
    },
    {
      question: intl.formatMessage({ defaultMessage: 'How do I get paid?', id: 'Ji9Fjy' }),
      answer: intl.formatMessage({
        defaultMessage:
          'Payments are deposited directly into your bank 24 - 48 hours after your RV has departed.',
        id: 'FVmGFU',
      }),
    },
    {
      question: intl.formatMessage({
        defaultMessage: 'What does insurance cover?',
        id: 'z/9mSV',
      }),
      answer: intl.formatMessage({
        defaultMessage:
          "Outdoorsy's $1 million liability insurance policy covers your RV or trailer whenever it's being rented. You're also covered for theft and damage subject to our policies.",
        id: 'mVipb5',
      }),
    },
    {
      question: intl.formatMessage({ defaultMessage: 'Got more questions?', id: 'FzYXDd' }),
      answer: intl.formatMessage({
        defaultMessage: 'Check out our FAQ or give us a call at 1-877-723-7232.',
        id: 'Sc+vfg',
      }),
    },
  ];

  return (
    <section id="faqs" className={`${styles.spacing} text-center bg-white`}>
      <Text variant={ETextStyleVariant.LegalRegular} className="uppercase">
        <FormattedMessage defaultMessage="FAQS" id="PsZKr3" />
      </Text>
      <Heading variant={EHeadingStyleVariant.H3} className="mt-2 mb-6">
        <FormattedMessage defaultMessage="What hosts are asking about" id="Dspv0l" />
      </Heading>

      <Accordion allowMultipleOpen className="mt-12 mb-16 text-left">
        {rvFaqItems.map(item => (
          <Accordion.Item divider title={item.question} key={item.question}>
            {item.answer}
          </Accordion.Item>
        ))}
      </Accordion>

      <Heading variant={EHeadingStyleVariant.H4Alt} className="mb-8">
        <FormattedMessage defaultMessage="Ready to get started?" id="P+1fsm" />
      </Heading>
      <Button
        onClick={handleHostingFlow}
        variant={EButtonColorVariant.Primary}
        label={intl.formatMessage({ defaultMessage: 'Try hosting today', id: 'R7Xwt5' })}
        loading={loading}
      />
    </section>
  );
};
